import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import { useFormContext, useWatch } from "react-hook-form";
import { ExtractionQuery, PipelineConfig } from "../../../interfaces/doc";
import ArrayField from "./ArrayFields";
import {
  filterDisplayExtractionQueries,
  getField,
  getResultDefault,
} from "./ResultFormUtils";

export const ExtractionField: React.FC<{ query: ExtractionQuery }> = ({
  query,
}) => {
  const [parsing_type, custom_schema, enum_values] = useWatch({
    name: [
      `extraction.${query.id}.parsing_type`,
      `extraction.${query.id}.custom_schema`,
      `extraction.${query.id}.enum_values`,
    ],
  });
  const FormField = getField(parsing_type, custom_schema, enum_values);
  const getDefaultValue = () => getResultDefault(parsing_type, custom_schema);
  const getContent = () => {
    if ("many" in query && query.many) {
      return (
        <ArrayField
          extractionId={query.id}
          FormField={FormField}
          getDefaultValue={getDefaultValue}
        />
      );
    } else {
      return <FormField extractionId={query.id} />;
    }
  };
  return (
    <>
      <Typography fontWeight="bold" gutterBottom>
        {query.name}
      </Typography>
      {getContent()}
    </>
  );
};

const ExtractionForm: React.FC<{ config: PipelineConfig }> = ({ config }) => {
  const { watch } = useFormContext();
  const classification = watch("classification");
  return (
    <>
      {!!config.extraction &&
        filterDisplayExtractionQueries(
          config.extraction.queries,
          classification
        ).map((query) => (
          <>
            <ExtractionField key={query.id} query={query} />
            <Divider key={`${query.id}-divider`} sx={{ my: 2 }} />
          </>
        ))}
    </>
  );
};

export default ExtractionForm;
